class FabricsSelect extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.bindEvents();
    this.manageSelection();
    this.setSelectedContent()
  }

  bindEvents() {
    this.tabs = Array.from(this.querySelectorAll('.Toggle__tab'));
    this.contents = Array.from(this.querySelectorAll('.Carrier__tab'));

    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => this.handleTabClick(e));
    });

  }

  handleTabClick(event) {
    const tab = event.currentTarget;
    const activeTab = this.tabs.find(t => t.classList.contains('is-selected'));
    if(tab == activeTab) return;
    
    // Remove "is-selected" class from all tabs and add it to the clicked tab
    this.tabs.forEach(t => t.classList.remove('is-selected'));
    tab.classList.add('is-selected');
    this.setSelectedContent(tab);
    
  }

  manageSelection(){
    const selectedTabs = this.tabs.filter(tab=>tab.classList.contains('is-selected'))
    if(selectedTabs.length <= 1) return;

    selectedTabs.forEach((tab, index)=>tab.classList.toggle("is-selected", index === 0))
  }

  setSelectedContent(activeTab){
    const tab = activeTab ? activeTab : this.tabs.find(tab => tab.classList.contains('is-selected'));
    
    if (!tab) return;
    // Get the category from the clicked tab's data-category attribute
    const selectedCategory = tab.getAttribute('data-category');
    // Hide all content blocks and remove "is-selected" class
    this.contents.forEach(contentTab => {
      const isActive = contentTab.getAttribute('data-category') === selectedCategory;
      contentTab.classList.toggle('is-selected', isActive);
    });

  }
}

// Define the custom element
customElements.define('fabrics-select', FabricsSelect);